<div class="pb-3">
  <a [routerLink]="['/seller/catalog']" class="font-semibold">
    <i
      class="pi pi-angle-left"
      style="border: 1px solid; border-radius: 50%; vertical-align: middle; padding-top: 1px; padding-right: 1px"></i>
    <span class="pl-1" style="vertical-align: bottom"> {{'catalog.returnToCatalog' | translate }} </span>
  </a>
</div>
<div class="font-semibold text-xl pb-4">
  <i class="pi pi-shop bg-icon"></i>
  <span class="pl-2" style="font-size: 1.2rem">{{ product?.title }}</span>
</div>
<p-card class="relative">
  <div class="flex pb-3">
    <div class="flex-1"></div>
    <div>
      <!-- <p-button [outlined]="true" styleClass="vertical-align-middle"  (click)="openHistoryDialog()">
        <i class="pi pi-clock"></i>
        <span class="pl-2">{{'global.history' | translate}}</span>
      </p-button> -->
    </div>
  </div>
  <div class="grid">
    <div class="col-12 grid">
      <div class="lg:col-6 sm:col-12 md:col-8">
        <div class="flex mb-3">
          <span class="font-bold inline-block mr-2 flex-1" style="font-size: 1.1rem">
            {{ "detailProduct.masterProduct" | translate }}
            <i class="pi pi-lock"></i>
          </span>
          @if(product?.mergedProduct.status) {
            <p-tag
              [severity]="getSeverityForPublicationStatus(product?.mergedProduct.status , product)"
              value="{{ product?.mergedProduct.status | translate }}"
              [tp]="tpl">
              <ng-template #tpl>
                <div class="flex align-items-center text-justify p-2" style="font-size: 11px">
                  {{ product.mergedProduct.status | translate }}
                </div>
              </ng-template>
            </p-tag>
          }

        </div>
        <div class="flex master-product">
          <div>
            @if (product?.mergedProduct.image) {
              <img
                [src]="product?.mergedProduct.image.trim()"
                alt="Main product"
                style="width: 60px; height: 60px; object-fit: cover" />
            } @else {
              <p-skeleton width="60px" height="4rem" />
            }
          </div>
          <div class="pl-3" style="width: 100% !important;">
            <p-timeline [value]="steps" layout="horizontal">
              <ng-template pTemplate="marker" let-event>
                <p-tag [value]="event.tag" [severity]="Util.getSeverity(event.summary.trim())" [class]="'step-tag'"></p-tag>
              </ng-template>
              <ng-template pTemplate="content" let-event>
                <div [tp]="tpl" [tpPlacement]="'bottom'" [tpPopperWidth]="'350px'" style="font-size: 0.8rem">
                  <div style="color: #757575" class="timeline-content">
                    {{ event.header.trim() | translate }}
                  </div>
                   @if(event.summary.trim() == 'SYNCHRONIZED' || event.summary.trim() == 'NOT_SYNCHRONIZED'){
                    <div
                      class="font-semibold timeline-content"
                      [class]="'text-color-' + getSeverityForPublicationStatus(event.summary.trim(), product)">
                      {{ event.summary.trim() | translate }}
                    </div>
                   }@else {
                    <div
                      class="font-semibold timeline-content"
                      [class]="'text-color-' + Util.getSeverity(event.summary.trim())">
                      {{ event.summary.trim() | translate }}
                    </div>
                   }
                  
                  @if (event.date) {
                    <div class="timeline-content">{{ event.date }}</div>
                  }
                </div>
                <ng-template #tpl>
                  <div class="flex align-items-center text-justify p-2" style="font-size: 11px">
                    {{ event.tooltip | translate }}
                  </div>
                </ng-template>
              </ng-template>
            </p-timeline>
          </div>
        </div>
      </div>
      <div class="lg:col-6 sm:col-12 md:col-4">
        <div style="margin-bottom: 1.25rem">
          <span class="font-bold inline-block pl-5 mr-3" style="font-size: 1.1rem">
            {{ "sellerProduct.yourProduct" | translate }}
          </span>
          <!-- <span class="link font-bold">
            <i class="pi pi-inbox font-bold"></i>
            {{ 'global.archive' | translate }}
          </span> -->
        </div>
        <div class="flex seller-product" style="padding: 1rem 0.5rem">
          <div class="mr-3 ml-3">
            @if (product?.images[0].url) {
              <img [src]="product?.images[0].url" alt="product" style="width: 60px; height: 60px; object-fit: cover" />
            } @else {
              <p-skeleton width="60px" height="4rem" />
            }
          </div>
          <div class="ml-5 h-full m-auto">
            <div class="pl-2 flex flex-column justify-content-between pt-1 pb-1 align-self-end">
              <div class="font-bold pb-1">
                <i class="pi pi-shop"></i>
                <span> {{ selectedShop.shopName }} </span>
              </div>
              <div>
                <div class="pb-1">
                  {{ "detailProduct." + product?.status.statusCode | translate }}
                  <span [class]="'text-color-' + Util.getSeverity(product?.status.statusText.trim())" class="font-semibold">
                    {{ product?.status.statusText | translate }}
                  </span>
                </div>

                <div class="pb-1">{{ product?.status.statusDate }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12 grid pt-0">
    <div class="col-5"></div>
  </div>
</p-card>

@if (messages.length > 0) {
   @for(message of messages; track $index){
    <p-message [severity]="Util.getMessageSeverity(message.severity)">
        <div class="ml-2">
          <div class="font-semibold">{{ message.severity | translate }} - {{ message.summary | translate }}</div>
          <div>
             @if(Util.isArray(message.detail) ) {
                @for(msg of Util.getDetailArray(message.detail); track $index) {
                  @if(msg.length > 250) {
                    <div class="message-item" [ngClass]="expandedStates[$index] ? 'message-expanded' : 'message-collapsed'">
                      <div class="message-text">
                        {{ expandedStates[$index] ? msg : (msg | slice:0:250) + '...' }}
                      </div>
                      <div class="expand-button mt-1">
                        <p-button 
                          [icon]="expandedStates[$index] ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
                          [label]="expandedStates[$index] ? 'Réduire' : 'Voir plus'"
                          size="small"
                          [text]="true"
                          (onClick)="toggleExpand($index)">
                        </p-button>
                      </div>
                    </div>
                  } @else {
                    <div class="message-short">
                      <div class="message-text">{{ msg }}</div>
                    </div>
                  }
                }
            } @else {
              <span>{{ message.detail }}</span> 
            }
          </div>
        </div>
    </p-message>
  }
}
<p-message class="messages" severity="info" [closable]="false">
    <div class="ml-2">
      <div class="mb-3">
        <span class=" custom-link" [innerHTML]="'products.productLifeCycleDetail' | translate"></span>
        <a class="custom-link underline pl-1" target="_blank" [href]="getTutoLink()">{{
          'products.tutoLink' | translate
          }}</a>
      </div>
      <span class="font-semibold">{{'products.moreInfo' | translate}} 
        <button class="document-link" type="button"  (click)="onDownload()">
          <i class="pi pi-download mr-2"></i>
          {{'products.downloadDoc' | translate}}
        </button>
      </span>
    </div>
</p-message>

<p-card>
  @if (product && categories) {
    <app-product-attributes
      (update)="refreshProduct($event)"
      [product]="product"
      [disabled]="true"
      [categories]="categories"
      [operator]="false"
      #productAttributes></app-product-attributes>
  }
</p-card>
